module.exports = __webpack_public_path__ + "public/static/img/recover-password-page-img-01.68947a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recover-password-page-img-01.svg
// module id = dxLI
// module chunks = 1